import { render, staticRenderFns } from "./EditArticlePendingInternal.vue?vue&type=template&id=484198c6&scoped=true"
import script from "./EditArticlePendingInternal.vue?vue&type=script&lang=js"
export * from "./EditArticlePendingInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484198c6",
  null
  
)

export default component.exports